import React from 'react'

export const CellContext = React.createContext(null)

export const CellProvider = ({ id, children }) => {
  return <CellContext.Provider value={id}>{children}</CellContext.Provider>
}
